import {isFunction} from '@malt/common';
import {store} from './store';

export function destroyObj(id) {
    const obj = store.remove(id);
    if (obj && isFunction(obj.destroy)) {
        obj.destroy();
    }
}
